/**** mgt.RaspTime */
import moment       from 'moment';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const dowToDay: { [key: string]: string } = {
  '1': 'Понедельник',
  '2': 'Вторник',
  '3': 'Среда',
  '4': 'Четверг',
  '5': 'Пятница',
  '6': 'Суббота',
  '0': 'Воскресенье',
};

const config = {
  schema: 'mgt',
  table: 'RaspTime',
  title: 'Плановые времена отправлений по ОП',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    stops: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Stops',
      index: 'stop_id',
      fields: ['stop_name'],
      format: (elem: any) => elem['stop_name'],
      autocomplete: true,
    },
    raspvars: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'RaspVariants',
      index: 'id',
      fields: ['id', 'route_short_name', 'dow', 'startdate', 'enddate', 'srv_id'],
      customsql: `SELECT vr.id, rt.route_short_name,vr.dow, vr.startdate, vr.enddate, vr.srv_id
                  FROM mgt."RaspVariants" vr
                  INNER JOIN mgt."Routes" rt ON rt.route_id=vr.route_id`,
      format: (elem: any) =>
        `${elem['route_short_name']} - ${dowToDay[elem['dow'] + ''] ||
        'Любой день'} (${ elem['startdate'] ? moment(elem['startdate']).format('DD.MM.YYYY') : '?' }-${ elem['enddate'] ? moment(elem['enddate']).format('DD.MM.YYYY') : '?' }, ${elem['srv_id']})`,
        autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'RaspVariant_id',
      title: 'Вариант расписания',
      type: 'number',
      required: true,
      connection: 'raspvars',
    },
    {
      name: 'graph',
      title: 'Номер выхода',
      type: 'number',
      required: true,
    },
    {
      name: 'smena',
      title: 'Номер смены',
      type: 'text',
      required: true,
    },
    {
      name: 'racetype',
      title: 'Тип рейса',
      type: 'text',
      required: true,
    },
    {
      name: 'racenum',
      title: '№ рейса',
      type: 'number',
      required: true,
    },
    {
      name: 'order',
      title: 'Порядковый номер остановки',
      type: 'number',
      required: true,
    },
    {
      name: 'stop_id',
      title: 'Остановка',
      type: 'number',
      required: true,
      connection: 'stops',
    },
    {
      name: 'time',
      title: 'Время отправления (посещения) ОП',
      type: 'timeminutes',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    RaspVariant_id: null,
    graph: null,
    smena: null,
    racetype: null,
    racenum: null,
    order: null,
    stop_id: null,
    time: null,
  },
  // makeIdOnInsert: true,
  updateField: 'update_date',
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'service_id',
        field: 'gr_id',
      },{
        title: 'grafic',
        field: 'graph',
      },{
        title: 'shift_num',
        field: 'smena',
      },{
        title: 'trip_id',
        field: 'trip_id',
      },{
        title: 'trip_num',
        field: 'racenum',
      },{
        title: 'stop_num',
        field: 'order',
      },{
        title: 'stop_id',
        field: 'stop_id',
      },{
        title: 'arrival_time',
        field: 'time',
      }
    ],
    example: `1;100;1;1;1;1;1;01:00`,
    customInsert: 'function (elem, nextIdFunc) { \
      const time = elem.time.split(":").reduce((last, cur, index) => last+parseInt(cur)*(index==0?60:1) ,0);\
      let sql = `INSERT INTO mgt."RaspTime"( \
        gr_id, "order", graph, smena, racetype, stop_id, "time", racenum, "RaspVariant_id", update_date, do_not_update) \
        SELECT ${elem.gr_id} as gr_id, ${elem.order} as "order", ${elem.graph} as graph, \
               ${elem.smena} as smena, tr.race_type as racetype, ${elem.stop_id} as stop_id, ${time} as "time", \
               ${elem.racenum} as racenum, rsv.id as "RaspVariant_id", now() as update_date, false as do_not_update \
          FROM mgt."Trip" tr \
            INNER JOIN mgt."MarshVariants" mv ON tr."MarshVariant_id"=mv.id \
            INNER JOIN mgt."RaspVariants" rsv ON rsv.route_id = mv.route_id and rsv.srv_id = ${ elem.gr_id }\
            WHERE tr.id=${elem.trip_id};`; \
      return sql; \
    }'
  },
  export: {
    fields: [
      {
        name: 'RaspVariant_id',
        title: 'Вариант расписания',
        connection: 'raspvar',
        connectionGetField: 'raspvar',
      },
      {
        name:             'route_name',
        title:            'Маршрут',
        connection:       'routes',
        connectionKey:    'stop_id',
        connectionGetField: 'route_short_name',
      },
      {
        name:             'route_type',
        title:            'Тип ТС',
        connection:       'vehicle_type',
        connectionKey:    'stop_id',
        connectionGetField: 'route_type',
      },
      {
        name: 'graph',
        title: 'Номер выхода',
      },
      {
        name: 'smena',
        title: 'Номер смены',
      },
      {
        name: 'racetype',
        title: 'Тип рейса',
      },
      {
        name: 'racenum',
        title: '№ рейса',
      },
      {
        name: 'order',
        title: 'Порядковый номер остановки',
      },
      {
        name: 'stop_id',
        title: 'Остановка',
        connectionGetField: 'stop_name'
      },
      {
        name: 'time',
        title: 'Время отправления (посещения) ОП',
        type: 'minutes'
      }
    ],
    connections: {
      raspvar: {
        index: 'RaspVariant_id',
        customsql: 
          `
            SELECT
                r.route_short_name ||  ' - ' ||
                CASE
                    WHEN rv.dow IS NULL THEN 'Любой день'
                    WHEN rv.dow = 0 THEN 'воскресенье'
                    WHEN rv.dow = 1 THEN 'понедельник'
                    WHEN rv.dow = 2 THEN 'вторник'
                    WHEN rv.dow = 3 THEN 'среда'
                    WHEN rv.dow = 4 THEN 'четверг'
                    WHEN rv.dow = 5 THEN 'пятница'
                    WHEN rv.dow = 6 THEN 'суббота'
                    ELSE 'неизвестно'
                end ||  ' (' ||
                COALESCE(rv.startdate::date::text, '?') ||  ' - ' ||  COALESCE(rv.enddate::date::text, '?') || ')'
                AS raspvar
            FROM
                mgt."RaspTime" rt
            INNER JOIN
                mgt."RaspVariants" rv ON rt."RaspVariant_id" = rv.id
            INNER JOIN 
                mgt."Routes" r ON rv.route_id = r.route_id
          `
      }
    },
    routes:   {
        index: 'stop_id',
        customsql:
          `SELECT
              r.route_short_name,
          FROM
              mgt."RaspTime" rt
          INNER JOIN
              mgt."Stops" s on rt.stop_id = s.stop_id
          INNER JOIN
              mgt."RaspVariants" rv ON rt."RaspVariant_id" = rv.id
          INNER JOIN
              mgt."Routes" r ON rv.route_id = r.route_id`
      },
      vehicle_type: {
        index: 'stop_id',
        customsql:
          `
            SELECT
                v.route_type
            FROM
                mgt."RaspTime" rt
            INNER JOIN
                mgt."Stops" s on rt.stop_id = s.stop_id
            INNER JOIN
                mgt."RaspVariants" rv ON rt."RaspVariant_id" = rv.id
            INNER JOIN
                mgt."Routes" r ON rv.route_id = r.route_id
            INNER JOIN
                mgt."Vehicle_Task" vt ON rv.id = vt."RaspVariant_id"
            INNER JOIN
                mgt."Vehicle" v ON vt.vehicle_id = v.vehicle_id
          `,
      },
  }
};

export default config;
